import { createReducer, on, Action } from '@ngrx/store';
import * as orderLinesActions from '../actions/order-lines.actions';
import { OrderLineApiModel } from 'app/models/order-line-api.model';
import * as userActions from '@core/auth/@store/user/user.actions';

export interface State {
  orderLines: OrderLineApiModel[];
  orderLineCount: number;
  isLoading: boolean;
  isReady: boolean;
}

export const initialState: State = {
  orderLines: [],
  orderLineCount: 0,
  isLoading: false,
  isReady: false,
};

const featureReducer = createReducer(
  initialState,
  on(orderLinesActions.loadOrderLines, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(
    orderLinesActions.loadOrderLinesSuccess,
    (state: State, { payload: response }) => ({
      ...state,
      isLoading: false,
      isReady: true,
      orderLines: response.results,
      orderLineCount: response.count,
    })
  ),
  on(
    orderLinesActions.resetOrderLines,
    userActions.setActiveCompany,
    (state: State) => initialState
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
